import React from "react";
import Page from "@jumbo/shared/Page";
import ChangePassword from "app/pages/app-pages/changePassword/ChangePassword";
import ManageJobs from "app/pages/app-pages/manage-jobs/ManageJobs";
import CreateJob from "app/pages/app-pages/manage-jobs/CreateJobs";
import UpdateJob from "app/pages/app-pages/manage-jobs/UpdateJobs";
import AppliedJobList from "app/pages/app-pages/appliedJobs/AppliedJobList";
import CreateJobCategory from "app/pages/app-pages/jobCategory/CreateJobCategory";
import ManageJobsCategory from "app/pages/app-pages/jobCategory/jobCategoryList";
import UpdateJobCategory from "app/pages/app-pages/jobCategory/updateJobCategory";
import ManageJobSkill from "app/pages/app-pages/jobSkill/jobSkillList";
import CreateJobSkill from "app/pages/app-pages/jobSkill/CreateJobSkill";
import UpdateJobSkill from "app/pages/app-pages/jobSkill/updateJobSkill";
import ManageDegreeLevel from "app/pages/app-pages/degreeLevel/DegreeLevelList";
import CreateDegreeLevel from "app/pages/app-pages/degreeLevel/CreateDegreeLevel";
import UpdateDegreeLevel from "app/pages/app-pages/degreeLevel/updateDegreeLevel";
import ViewApplication from "app/pages/app-pages/appliedJobs/ViewApplication";
import ViewJobs from "app/pages/app-pages/manage-jobs/ViewJobs";
import ManageEnquiry from "app/pages/app-pages/manageEnquiry/ManageEnquiry";
import EnquiryView from "app/pages/app-pages/manageEnquiry/EnquiryView";

const appRoutes = [
  
  {
    path: "/change-password",
    element: <Page component={ChangePassword} layout={"admin-layout"} />,
  },
  {
    path: "manage-job",
    element: <Page component={ManageJobs} layout={"admin-layout"} />,
  },
  {
    path: "manage-job/create",
    element: <Page component={CreateJob} layout={"admin-layout"} />,
  },
  {
    path: "manage-job/update/:id",
    element: <Page component={UpdateJob} layout={"admin-layout"} />,
  },
  {
    path: "manage-job/view/:id",
    element: <Page component={ViewJobs} layout={"admin-layout"} />,
  },

  {
    path: "settings/manage-job-category",
    element: <Page component={ManageJobsCategory} layout={"admin-layout"} />,
  },
  {
    path: "settings/manage-job-category/create",
    element: <Page component={CreateJobCategory} layout={"admin-layout"} />,
  },
  {
    path: "settings/manage-job-category/update/:id",
    element: <Page component={UpdateJobCategory} layout={"admin-layout"} />,
  },
  

  {
    path: "settings/manage-job-skill",
    element: <Page component={ManageJobSkill} layout={"admin-layout"} />,
  },
  {
    path: "settings/manage-job-skill/create",
    element: <Page component={CreateJobSkill} layout={"admin-layout"} />,
  },
  {
    path: "settings/manage-job-skill/update/:id",
    element: <Page component={UpdateJobSkill} layout={"admin-layout"} />,
  },
  {
    path: "settings/manage-degree-level",
    element: <Page component={ManageDegreeLevel} layout={"admin-layout"} />,
  },
  {
    path: "settings/manage-degree-level/create",
    element: <Page component={CreateDegreeLevel} layout={"admin-layout"} />,
  },
  {
    path: "settings/manage-degree-level/update/:id",
    element: <Page component={UpdateDegreeLevel} layout={"admin-layout"} />,
  },
  {

    path: "job-application",
    element: <Page component={AppliedJobList} layout={"admin-layout"} />,
  },
  {
    path: "job-application/view/:id",
    element: <Page component={ViewApplication} layout={"admin-layout"} />,
  },
  {
    path: "manage-enquiry",
    element: <Page component={ManageEnquiry} layout={"admin-layout"} />,
  },
  {
    path: "manage-enquiry/view/:id",
    element: <Page component={EnquiryView} layout={"admin-layout"} />,
  }
  /*  {
         path: "/test",
         element: <Page component={Test} layout={"admin-layout"} />,
        }, */
];

export default appRoutes;
